import { render, staticRenderFns } from "./PayInvoice.vue?vue&type=template&id=485f921f"
import script from "./PayInvoice.vue?vue&type=script&lang=js"
export * from "./PayInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports